<template>
  <div style="padding-bottom: 20px">
    <div id="videoPlayer" class="video-js videoBox" :key="playNum"></div>
    <div class="videoNme">
      <div class="name">{{ videoInfo.cwName }}</div>
      <div class="hangye">所属课程：{{ courseName }}</div>
    </div>

    <div class="tab">
      <div :class="tabIndex == '1' ? 'tablan active' : 'tablan'" @click="tabIndex = 2">
        温馨提示
        <div class="bor" v-if="tabIndex == '1'"></div>
      </div>
    </div>
    <div v-if="tabIndex == '1'" class="wxts">
      <div style="color: red">重要提示：学习时请勿拖动进度条，刷新页面，倍速等操作，否则将无法进行学时记录</div>
      <div>1.请到“账号管理”界面完善个人信息，这将有利于为您快速登记学时证明；</div>
      <div>2.如果视频无法播放，推荐使用QQ浏览器；</div>
      <div>3.课程学习通过后可到学习中心“继续教育”界面自主打印学时证明；</div>
      <div>4.如您需要发票请到“订单管理”界面点击“申请开票”，输入发票信息，申领电子发票;</div>
      <div>5.所报名班级下的所有课程全部学习完成才能生成证书。</div>
    </div>

    <div class="tk" v-if="bmShow">
      <div class="wtkBox">
        <img class="tkBac" src="../../assets/images/bgcJu@2x.png" alt="" />
        <div class="wxTtile">温馨提示</div>

        <div class="wx2">{{ bmText }}前往<span style="color: #2d72f3">继续教育专区</span>选课购买。</div>

        <div class="wxBtn" @click="goBm">立即前往报名</div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import MyPlayIcon from '../../assets/images/bg_01.png';
import MyPauseIcon from '../../assets/images/bmxk@2x.png';
import 'xgplayer';
import Player from 'xgplayer';
import HlsPlugin from 'xgplayer-hls';
import { toStudy, updateDBTrack, toAllReadyBuy } from '@/api/myClass';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      bmShow: false,
      bmText: '',
      tabIndex: 1,
      TMvalid: false, //是否需要验证码，false不需要
      dialogVisible: false, //验证码弹框
      codeNum: '', //验证码结果
      configKey: '', //tm平台需要的key
      codeImg: '', //验证码图片
      codeId: '', //提交验证码必要参数
      chapterid: '', //提交验证码必要参数
      tmId: '', //提交验证码必要参数
      coursePlayTimeList: [],
      isNeedVerify: '', //是否需要验证
      codeResTime: '', //验证时间
      codeIndex: '',
      userId: '',
      getVerCodeTime: 1, //1分钟
      everyProVideo: 15, //假定视频总长度
      isVerify_0: false, //
      verifyChapter: '',
      verCodeCount: 0,
      codeStatus: false, //验证码检查状态
      isGetTmVerCodeByVideoPlayTimer: null, //定时器
      options: {
        autoplay: true, // 设置自动播放
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        preload: 'auto', // 预加载
        controls: true // 显示播放的控件
      },
      player: null,
      queryPams: {},
      chapterList: [], //目录
      videoInfo: {}, //当前播放数据
      lessonstatus: '', //学习状态0
      videoTime: 0,
      timer: null,
      allInt: false, //视频是否已完成 false未完成 true已完成
      className: '1',
      t: false, //是pc还是移动端
      jinDuId: '', //动态渲染当前播放视频进度
      foj: '', //进度
      isExam: '',
      zanKey: 0, //
      zanKey1: 1000, //
      courseName: '',
      timer1: null,
      playNum: 1
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    toAllReadyBuy() {
      toAllReadyBuy().then(res => {
        if (res.data.data.msg == '') {
          this.bmShow = false;
        } else {
          this.bmShow = true;
        }
        this.bmText = res.data.data.msg;
      });
    },
    goBm() {
      this.$router.push({
        path: '/chooseClass',
        query: {
          type: '0702'
        }
      });
    },
    //展开收起
    seletZan(item) {
      item.zan = !item.zan;
      console.log(item);
      this.zanKey = this.zanKey + 1;
      this.zanKey1 = this.zanKey1 + 10;
    },
    //提交验证码
    codeSubmit() {
      let data = {
        chapterId: this.chapterid,
        codeId: this.codeId,
        codeAnswer: this.codeNum,
        tmId: this.tmId
      };
      sendCodeAnswer(data).then(res => {
        console.log(res);
        //成功后关闭弹框
        if (res.data.data.data.verifyResult == '1') {
          this.dialogVisible = false;
        } else {
          this.dialogVisible = false;
          this.$message('回答错误！请重新验证');
          this.getTmVerCode(this.codeResTime);
        }
      });
    },
    //获取公需课平台验证数据
    getTrainSupervision() {
      if (this.TMvalid) {
        getTrainSupervision({ userId: this.userId, courseId: this.$route.query.courseId, classId: this.$route.query.classId }).then(tim => {
          if (tim.data.data.isNeedVerify == '00') {
            return false;
          }
          tim.data.data.data = JSON.parse(tim.data.data.data);
          this.coursePlayTimeList = tim.data.data.data.coursePlayTimeList;
          console.log('this.coursePlayTimeList', this.coursePlayTimeList);
          this.tmId = tim.data.data.tmId;
          this.configKey = tim.data.data.data.configKey;
          this.isNeedVerify = tim.data.data.isNeedVerify;
          this.verifyChapter = tim.data.data.verifyChapter;
          if (tim.data.data.error !== '') {
            this.$message('系统异常！');
            this.goBack();
          } else if (tim.data.data.isNeedVerify == '01' && this.verifyChapter.indexOf(this.chapterid) == -1) {
            this.initGetTmVerCode();
          }
        });
      }
    },
    goExam() {
      window.location.replace(this.isExam.quizUrl + '&token=' + localStorage.getItem('token'));
    },
    goStudy() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      getUrl().then(res => {
        if (isMobile) {
          window.location.replace(res.data.data.mobileCenterUrl + '?token=' + localStorage.getItem('token'));
        } else {
          window.location.replace(res.data.data.pcCenterUrl + '?token=' + localStorage.getItem('token'));
        }
      });
    },
    toShow(index) {
      this.t = index;
    },
    navTab(id) {
      this.className = id;
    },
    initGetTmVerCode() {
      //需要验证
      //需要验证
      this.coursePlayTimeList.forEach(coursePlayTime => {
        if (coursePlayTime.isVerify == 0) {
          setTimeout(() => {
            this.isVerify_0 = true;
            this.getTmVerCode(coursePlayTime.playTime);
          }, 1000 * 60 * this.getVerCodeTime);
        }
        return;
      });

      if (this.isVerify_0) {
        return;
      }
      this.isGetTmVerCodeByVideoPlayTimer = setInterval(() => {
        console.log(Math.floor(this.player.currentTime));
        //没有规定时间的情况,需自己计算时间传给后端
        if (Math.floor(this.player.currentTime) == this.getVerCodeTime * 60) {
          clearInterval(this.isGetTmVerCodeByVideoPlayTimer);
          //已经成功验证过第几次  从已经验证的章节列表获取
          if (this.verifyChapter == '') {
            //未验证通过过
            this.verCodeCount = 0;
          } else {
            this.verCodeCount = this.verifyChapter.split('_').length;
          }

          //playTime 课程播放时间，单位:秒，如：课程进度在 2401 秒弹出验证码
          var playTime = this.verCodeCount * this.everyProVideo * 60 + this.getVerCodeTime * 60;

          this.getTmVerCode(playTime);
        }
      }, 1000);
    },

    goBack() {
      this.$router.back();
      // this.$router.push({ path: '/pattern', query: { classId:this.$route.query.classId, id: this.queryPams.courseId, courseWareId: this.queryPams.coursewareId } });
    },
    timeupdate(e) {
      if (this.allInt) {
        return false;
      }
      // this.videoTime = this.videoTime + 0.25;
      // if (this.player.currentTime - (this.videoInfo.chapterhours + this.videoTime) > 10) {
      //   this.player.currentTime = this.videoInfo.chapterhours + this.videoTime;
      // }
    },
    //视频结束事件
    endVideo(t) {
      if (this.allInt) {
        let info = this.videoInfo.isFinal;
        let chapterId = this.videoInfo.chapterId;
        if (info == '1') {
          if (this.videoInfo.nextChapterId == '0') {
            return false;
          }
          //该视频是当前章节的最后一个,那么就重新调用接口,访问下一个。
          // this.queryPams.classId = this.$route.query.classId;
          // this.queryPams.courseId = this.videoInfo.nextCourseId;
          // this.queryPams.coursewareId = this.videoInfo.nextCwId;
          // this.queryPams.chapterId = this.videoInfo.nextChapterId;
          // toStudy(this.queryPams).then(res => {
          //   if (res.data.data.chapter.lessonstatus == 'completed') {
          //     this.allInt = true;
          //   } else {
          //     this.allInt = false;
          //   }
          //   this.videoInfo = res.data.data.chapter;
          //   this.getVideo(this.videoInfo);
          // });
        } else {
          //如果不是最后一个，就正常播放下一个视频
          // this.chapterList.forEach((item, index) => {
          //   if (item.chapterId == chapterId) {
          //     item.zan = true; //打开正在播放的
          //     if (item.lessonstatus == 'completed') {
          //       item.jinDu = 100;
          //     } else {
          //       let time = this.player.currentTime;
          //       item.jinDu = parseInt((time / this.player.duration) * 100);
          //     }
          //     this.videoChange(this.chapterList[index + 1]);
          //   }
          //   if (item.chapterId == chapterId) {
          //   }
          // });
        }
        return false;
      }
      if (this.videoInfo.period - parseInt(this.player.currentTime) <= 60) {
        this.lessonstatus = 'completed';
      } else {
        this.lessonstatus = 'incomplete';
      }
      console.log('this.videoInfo: ', this.videoInfo);
      var position = parseInt(this.player.currentTime), //当前视频播放时长
        duration = this.videoInfo.period, //章节总时长
        courseId = this.queryPams.courseId, //课程id
        coursewareId = this.videoInfo.cwId, //课件id
        chapterId = this.videoInfo.chapterId, //章节id
        trackMode = this.videoInfo.cwScorm, //视频跟踪类型（01按时间点跟踪、02按知识点跟踪）
        lessonstatus = this.lessonstatus, //学习状态
        classId = this.queryPams.classId;
      let cwPeriod = this.videoInfo.cwPeriod;
      let creditnum = this.videoInfo.creditnum;
      let period = this.videoInfo.period;
      // lessonLocation = this.dataMsg.lessonLocation, //当前章节时长
      // suspendData = this.dataMsg.suspendData,
      let flag = '0'; //是否为老学员，默认0
      var params = {
        position: position,
        duration: duration,
        courseId: courseId,
        coursewareId: coursewareId,
        chapterId: chapterId,
        trackMode: trackMode,
        lessonstatus: lessonstatus,
        classId: classId,
        // lessonLocation: lessonLocation,
        // suspendData: suspendData,
        flag: flag,
        cwPeriod: cwPeriod,
        creditnum: creditnum,
        period: period
      };
      updateDBTrack(params).then(res => {
        let info = this.videoInfo.isFinal;
        let chapterId = this.videoInfo.chapterId;
        if (info == '1') {
          if (this.videoInfo.nextChapterId == '0') {
            return false;
          }
          //该视频是当前章节的最后一个,那么就重新调用接口,访问下一个。
          this.queryPams.classId = this.$route.query.classId;
          this.queryPams.courseId = this.videoInfo.nextCourseId;
          this.queryPams.coursewareId = this.videoInfo.nextCwId;
          this.queryPams.chapterId = this.videoInfo.nextChapterId;
          this.videoInfo = 0;
          toStudy(this.queryPams).then(res => {
            if (res.data.data.chapter.lessonstatus == 'completed') {
              this.allInt = true;
            } else {
              this.allInt = false;
            }
            this.videoInfo = res.data.data.chapter;
            this.getVideo(this.videoInfo);
          });
        } else {
          //如果不是最后一个，就正常播放下一个视频
          this.chapterList.forEach((item, index) => {
            if (item.chapterId == chapterId) {
              let time = this.player.currentTime;
              item.jinDu = parseInt((time / this.player.duration) * 100) >= 100 ? 100 : parseInt((time / this.player.duration) * 100);
              console.log(item.jinDu, '进度2');
              this.videoChange(this.chapterList[index + 1]);
            }
            if (item.chapterId == chapterId) {
            }
          });
        }
      });
    },
    //两分钟记录一下时长
    updateDBTrack() {
      if (this.allInt) {
        return false;
      }
      if (this.videoInfo.period - parseInt(this.player.currentTime) <= 120) {
        this.lessonstatus = 'completed';
      } else {
        this.lessonstatus = 'incomplete';
      }
      var position = parseInt(this.player.currentTime), //当前视频播放时长
        duration = this.videoInfo.period, //章节总时长
        courseId = this.queryPams.courseId, //课程id
        coursewareId = this.videoInfo.cwId, //课件id
        chapterId = this.videoInfo.chapterId, //章节id
        trackMode = this.videoInfo.cwScorm, //视频跟踪类型（01按时间点跟踪、02按知识点跟踪）
        lessonstatus = this.lessonstatus, //学习状态
        classId = this.queryPams.classId;
      let cwPeriod = this.videoInfo.cwPeriod;
      let creditnum = this.videoInfo.creditnum;
      let period = this.videoInfo.period;
      // lessonLocation = this.dataMsg.lessonLocation, //当前章节时长
      // suspendData = this.dataMsg.suspendData,
      let flag = '0'; //是否为老学员，默认0
      var params = {
        position: position,
        duration: duration,
        courseId: courseId,
        coursewareId: coursewareId,
        chapterId: chapterId,
        trackMode: trackMode,
        lessonstatus: lessonstatus,
        classId: classId,
        // lessonLocation: lessonLocation,
        // suspendData: suspendData,
        flag: flag,
        cwPeriod: cwPeriod,
        creditnum: creditnum,
        period: period
      };
      updateDBTrack(params).then(res => {
        let info = this.videoInfo.chapterId;

        this.chapterList.forEach(item => {
          if (item.chapterId == info) {
            item.jinDu = parseInt(res.data.data.jindu);
          }
        });
      });
    },
    videoChange(item) {
      this.updateDBTrack();

      this.queryPams.classId = this.$route.query.classId;
      this.queryPams.courseId = item.courseId;
      this.queryPams.coursewareId = item.cwId;
      this.queryPams.chapterId = item.chapterId;
      toStudy(this.queryPams).then(res => {
        if (res.data.data.chapter.lessonstatus == 'completed') {
          this.allInt = true;
        } else {
          this.allInt = false;
        }
        this.videoInfo = res.data.data.chapter;
        this.getVideo(this.videoInfo);
        window.scrollTo(0, 0);
      });
    },
    getData() {
      this.queryPams.classId = this.$route.query.classId;
      this.queryPams.courseId = this.$route.query.courseId;
      this.queryPams.coursewareId = this.$route.query.courseWareId;
      this.queryPams.chapterId = this.$route.query.chapterId;
      this.isExam = '02';
      setTimeout(() => {
        toStudy(this.queryPams).then(res => {
          this.chapterid = res.data.data.chapter.chapterId;
          this.TMvalid = res.data.data.TMvalid;
          this.userId = res.data.data.userId;
          //this.getTrainSupervision();
          if (res.data.data.chapter.lessonstatus == 'completed') {
            this.allInt = true;
          } else {
            this.allInt = false;
          }
          this.videoInfo = res.data.data.chapter;
          this.getVideo(this.videoInfo);
        });
      }, 1000);
    },
    getVideo(videoUrl) {
      let data = [
        {
          title: '核心知识',
          content: [
            { title: '大模型微调', content: '让通用能力更加精准适配业务' },
            { title: '项目实战', content: '真实业务场景下的项目开发实践' },
            { title: '企业AI', content: '面向企业业务场景的人工智能应用' }
          ]
        },
        {
          title: '特色服务',
          content: [
            { title: '大模型微调', content: '让通用能力更加精准适配业务' },
            { title: '项目实战', content: '真实业务场景下的项目开发实践' },
            { title: '企业AI', content: '面向企业业务场景的人工智能应用' }
          ]
        }
      ];

      if (this.player !== null) {
        this.player.destroy('videoPlayer');
      }
      //中经网一路学的课程
      if (videoUrl.sourceVideo == '01' || videoUrl.sourceVideo == '02') {
        this.player = new Player({
          id: 'videoPlayer',
          url: videoUrl.launch,
          playsinline: true,
          autoplay: true,
          playbackRate: false,
          ignores: ['start'],
          fullscreen: false,
          disableGesture: true
        });
      } else {
        //判断视频源是否是m3u8的格式
        //正常课程
        if (/\.m3u8$/.test(videoUrl.launch)) {
          //判断视频源是否是m3u8的格式
          this.player = new Player({
            id: 'videoPlayer',
            url: videoUrl.launch,
            autoplay: true,
            playsinline: true,
            playbackRate: false,
            ignores: ['start'],
            fullscreen: false,
            disableGesture: true,
            plugins: [HlsPlugin] // 第二步
          });
        } else {
          let url = videoUrl.launch + '.mp4';
          this.player = new Player({
            id: 'videoPlayer',
            url: url,
            playsinline: true,
            autoplay: true,
            playbackRate: false,
            ignores: ['start'],
            fullscreen: false,
            disableGesture: true
          });
        }
      }

      // this.player.on('loadstart', function () {});
      // this.player.on('progress', function () {});
      // this.player.on('loadedmetadata', function () {});
      // this.player.on('canplaythrough', function () {});
      // this.player.on('waiting', function () {});

      // this.player.on('playing', function () {});

      this.player.controls.updatePlay;
      let _this = this;
      _this.player.on('play', function () {
        const btn = _this.player.controls.play;
        if (btn) {
          btn.classList.remove('xg-icon-play');
          btn.classList.add('xg-icon-pause');
        }
      });
      _this.player.on('pause', function () {
        //  _this.$utils.showToast('暂停了')
      });
      _this.player.on('ended', function () {
        _this.endVideo();
      });
      _this.player.on('loadeddata', function () {
        if (videoUrl.lessonstatus && videoUrl.lessonstatus == 'completed') {
          _this.player.currentTime = 0;
        } else {
          _this.player.currentTime = videoUrl.chapterhours;
          document.getElementsByClassName('xgplayer-progress')[0].style = 'pointer-events:none';
        }
      });
      // this.player.on('currentTime', function () {});
      // this.player.on('seeked', function () {});
      // this.player.on('ratechange', function () {});
      _this.player.on('timeupdate', function () {
        _this.timeupdate();
      });
      // this.player.on('volumechange', function () {});
      // this.player.on('stalled', function () {});
    },
    //获取验证码
    getTmVerCode(time) {
      this.codeResTime = time;
      let query = {
        playTime: time.toString(),
        configKey: this.configKey
      };
      getTmVerCode(query).then(res => {
        let result = JSON.parse(res.data.data.data);

        if (result.result == '200') {
          if (result.data.couldAnswerCount == -1 || (result.data.couldAnswerCount != -1 && result.data.remainAnswerCount > 0)) {
            this.codeImg = 'data:image/jpeg;base64,' + result.data.content;
            this.codeId = result.data.id;
            this.dialogVisible = true;
            this.player.pause();
          } else {
            this.getTmVerCode(this.codeResTime + this.getVerCodeTime * 60);
          }
        }
        if (result.result == '505') {
          return false;
        }

        if (result.result == '500' || result.data.result == '503') {
          this.$message('无权限，请联系管理员！');
          this.$router.back();
          return false;
        }

        if (result.result == '506') {
          this.codeStatus = true;
          //当前节点时间验证过了,验证下一个时间
          this.getTmVerCode(this.codeResTime + this.getVerCodeTime * 60);
          return false;
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.courseName = this.$route.query.courseName;
    this.getData();
    this.toAllReadyBuy();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.timer = setInterval(() => {
      this.updateDBTrack();
    }, 4 * 60 * 1000);
    // this.timer1 = setInterval(() => {
    //   // this.updateDBTrack();
    //   if (this.videoInfo.jinDu >= 100) {
    //     return false;
    //   }
    //   let num = parseInt((this.player.currentTime / this.player.duration) * 100);
    //   this.videoInfo.jinDu = num > 100 ? 100 : num;
    // }, 60 * 1000);
  },
  destroyed() {
    this.updateDBTrack();
    clearInterval(this.timer);
    clearInterval(this.timer1);
    if (this.player !== null) {
      this.player.destroy('videoPlayer');
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.tk {
  margin-top: 10px;
  padding: 0 15px;
  .wtkBox {
    width: 100%;
    height: 151px;
    position: relative;
    padding: 21px 22px 18px 25px;
    .tkBac {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 151px;
      z-index: -1;
    }
    .closeBox {
      width: 24px;
      height: 24px;
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translate(-50%);
      cursor: pointer;
    }

    .wxTtile {
      font-size: 13px;
      color: #333333;
    }
    .wx2 {
      margin-top: 12px;
      font-size: 14px;
      color: #333;
    }
    .wxBtn {
      margin-top: 13px;
      width: 120px;
      height: 40px;
      background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
      box-shadow: 0px 3px 4px 0px rgba(21, 85, 202, 0.31);
      border-radius: 20px 20px 20px 20px;
      text-align: center;
      font-size: 12px;
      line-height: 40px;
      color: #fff;
      cursor: pointer;
    }
  }
}
#videoPlayer {
  margin-top: 50px;
  width: 100% !important;
  height: 211px !important;
}
.videoNme {
  width: 100%;
  height: 84px;
  background: #ffffff;
  border-radius: 0px 0px 8px 8px;
  padding: 20px 15px;
  .name {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #333333;
    font-size: 16px;
  }
  .hangye {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
    margin-top: 7px;
    font-size: 13px;
  }
}

.tab {
  display: flex;
  margin-top: 28px;
  padding: 0 15px;
  .tablan {
    position: relative;
    margin-right: 26px;
    font-size: 15px;
    color: #333;
    .bor {
      position: absolute;
      bottom: 2px;
      left: 0;
      width: 64px;
      height: 5px;
      background: linear-gradient(90deg, #2a70f2 0%, rgba(42, 112, 242, 0) 100%);
      border-radius: 0px 0px 0px 0px;
    }
  }
  .active {
    font-size: 16px;
    font-weight: 600;
  }
}

.chaper {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  min-height: 498px;
  padding: 15px;
  .zjBox {
    margin-bottom: 35px;
    .activeTitle {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .activeColor {
      color: #2a70f2 !important;
    }
    .activeBtn {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .zjIndex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bq {
        width: 48px;
        height: 24px;
        background: #f6f8fa;
        border-radius: 4px 4px 4px 4px;
        color: #666666;
        font-size: 13px;
        text-align: center;
        line-height: 24px;
      }
      .wcd {
        color: #9d9d9d;
        font-size: 12px;
      }
    }
    .chName {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      margin: 10px 0 1px 0;
      font-weight: 500;
    }
    .xsOrBtn {
      display: flex;
      justify-content: space-between;
      .xs {
        margin-top: 8px;
        color: #999999;
        font-size: 13px;
      }
      .btn {
        margin-top: 4px;
        width: 74px;
        height: 32px;
        background: #f3f3f5;
        border-radius: 27px 27px 27px 27px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #2a70f2;
      }
    }
  }
}

.wxts {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  padding: 20px 15px;
  color: #666666;
  font-size: 13px;
  line-height: 25px;
}
</style>
